(function(){
  var money=function(c){return (window.Shopify&&Shopify.formatMoney)?Shopify.formatMoney(c,window.themeMoneyFormat):'R '+(c/100).toFixed(2);};
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  /* Every place below that builds HTML via string concatenation (cart
     lines, the add-to-cart popup, option labels, the wishlist grid) drops
     in a product/variant title or option value straight from a fetch
     response. Those values are merchant-controlled, not customer input,
     but nothing here should assume a product title can never contain
     "<" - a bad catalog import or a compromised staff account is enough to
     turn an unescaped title into stored markup rendered via innerHTML.
     Escaping it before it goes into any of those template strings costs
     nothing and closes that off regardless of source. */
  var escapeHtml=function(s){
    return String(s==null?'':s).replace(/[&<>"']/g,function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  };

  /* ---- content protection ----
     Blocks the casual "select all, copy, paste" lift of product copy and a
     right-click "save image as" - it does NOT stop a determined visitor:
     page source, a screen reader, browser reader mode, disabling
     JavaScript, and a plain screenshot all still work regardless, so this
     is a deterrent for casual copying, not real protection. Scoped off
     form fields and anything editable, since an email/address field still
     needs normal text selection and typing to work; body-level
     user-select:none in theme-ui.css carries the same exclusion. */
  document.addEventListener('contextmenu',function(e){
    if(e.target.closest('input,textarea,[contenteditable]'))return;
    e.preventDefault();
  });
  document.addEventListener('copy',function(e){
    if(e.target.closest('input,textarea,[contenteditable]'))return;
    e.preventDefault();
  });
  document.addEventListener('dragstart',function(e){
    if(e.target.tagName==='IMG')e.preventDefault();
  });

  /* reveal on scroll */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.setAttribute('data-reveal','in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.04});
  var scan=function(){$$('[data-reveal="out"]').forEach(function(n){io.observe(n);});};
  scan();

  /* mobile nav */
  var mnav=$('.mnav');
  $$('[data-mnav]').forEach(function(b){b.addEventListener('click',function(){if(mnav)mnav.classList.toggle('is-open');});});

  /* mega menu */
  $$('[data-mega]').forEach(function(t){
    var panel=$('#mega-'+t.getAttribute('data-mega'));
    if(!panel)return;
    t.addEventListener('mouseenter',function(){$$('.mega').forEach(function(p){p.classList.remove('is-open');});panel.classList.add('is-open');});
  });
  var hdr=$('.hdr');
  if(hdr)hdr.addEventListener('mouseleave',function(){$$('.mega').forEach(function(p){p.classList.remove('is-open');});});

  /* ---- announcement bar: rotate through messages ----
     Matches the live site's calm centered crossfade instead of a
     continuously scrolling marquee. No-op with 0 or 1 message. */
  $$('[data-ann]').forEach(function(ann){
    var msgs=$$('.ann__msg',ann);
    if(msgs.length<2)return;
    var i=0;
    setInterval(function(){
      msgs[i].classList.remove('is-active');
      i=(i+1)%msgs.length;
      msgs[i].classList.add('is-active');
    },5000);
  });

  /* cart drawer */
  var drawer=$('.drawer');
  var openDrawer=function(){if(drawer)drawer.classList.add('is-open');};
  var closeDrawer=function(){if(drawer)drawer.classList.remove('is-open');};
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-open]')){e.preventDefault();openDrawer();}
    if(e.target.closest('[data-cart-close]')||e.target.classList.contains('drawer__veil'))closeDrawer();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});

  var threshold=parseInt(document.body.getAttribute('data-free-ship')||'150000',10);

  function paintCart(cart){
    var n=cart.item_count;
    $$('[data-cart-count]').forEach(function(el){el.textContent=n;el.classList.toggle('is-on',n>0);});
    $$('[data-cart-total]').forEach(function(el){el.textContent=money(cart.total_price);});
    var body=$('[data-cart-lines]');
    if(body){
      if(!cart.items.length){
        body.innerHTML='<div style="margin:auto 0;text-align:center;display:flex;flex-direction:column;gap:16px">'+
          '<span class="mono" style="color:var(--muted)">Your bag is empty</span>'+
          '<a class="btn btn--ink" href="/collections/all">Start shopping</a></div>';
      } else {
        body.innerHTML=cart.items.map(function(i){
          return '<div class="line" data-key="'+i.key+'">'+
            '<div class="line__img"><img src="'+(i.image?i.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2'):'')+'" alt=""></div>'+
            '<div class="line__b"><span class="card__t">'+escapeHtml(i.product_title)+'</span>'+
            '<span class="mono-s">'+(i.variant_title?escapeHtml(i.variant_title):'')+'</span>'+
            '<div class="line__row"><div class="qty"><button data-qty="-1" aria-label="Decrease">-</button>'+
            '<input value="'+i.quantity+'" readonly><button data-qty="1" aria-label="Increase">+</button></div>'+
            '<span class="card__p">'+money(i.line_price)+'</span></div>'+
            '<button type="button" class="line__rm mono-s" data-line-remove="'+i.key+'">Remove</button>'+
            '</div></div>';
        }).join('');
      }
    }
    var pct=Math.min(100,(cart.total_price/threshold)*100);
    var left=Math.max(0,threshold-cart.total_price);
    $$('[data-ship-bar]').forEach(function(b){b.querySelector('i').style.width=pct+'%';b.classList.toggle('is-free',left===0);});
    $$('[data-ship-msg]').forEach(function(m){m.textContent=left>0?money(left)+' away from free shipping':'Free shipping unlocked';});
    var strip=$('.ship-strip');
    if(strip)strip.classList.toggle('is-on',n>0);
  }

  function refresh(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){paintCart(c);return c;});}
  refresh();

  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-qty]');
    if(q){
      var line=q.closest('.line');
      var input=line.querySelector('input');
      var next=Math.max(0,parseInt(input.value,10)+parseInt(q.getAttribute('data-qty'),10));
      fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:line.getAttribute('data-key'),quantity:next})})
        .then(function(r){return r.json();}).then(paintCart);
      return;
    }
    var rm=e.target.closest('[data-line-remove]');
    if(rm){
      fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:rm.getAttribute('data-line-remove'),quantity:0})})
        .then(function(r){return r.json();}).then(paintCart);
    }
  });

  /* ---- add-to-cart popup: confirmation state ----
     A centered, product-isolated confirmation instead of interrupting the
     page with the side drawer - built specifically to cut checkout
     friction: the primary action goes straight to /checkout, not /cart.
     The upsell row is seeded by whichever product was just added and
     pulled from Shopify's own recommendations endpoint, so it changes per
     product instead of repeating one fixed cross-sell. Also doubles as the
     option-picker for cards with real variants - see "quick add" below. */
  var popup=$('[data-cartpop]');
  var quickAddProduct=null;
  var quickAddSelection=[];

  function closePopup(){
    if(!popup)return;
    popup.classList.remove('is-open','is-choosing');
    quickAddProduct=null;
    quickAddSelection=[];
  }

  function openCartPopup(added){
    if(!popup||!added)return;
    var item=added.items?added.items[0]:added;
    if(!item)return;

    popup.classList.remove('is-choosing');
    var eyebrow=$('[data-cartpop-eyebrow]',popup);
    if(eyebrow)eyebrow.textContent='Added to your bag';

    var img=$('[data-cartpop-img]',popup);
    if(img){
      var src=item.image||(item.featured_image&&item.featured_image.url)||'';
      img.src=src?src.replace(/(\.[a-z]+)(\?|$)/i,'_400x$1$2'):'';
    }
    var titleEl=$('[data-cartpop-title]',popup);
    if(titleEl)titleEl.textContent=item.product_title||item.title||'';
    var varEl=$('[data-cartpop-variant]',popup);
    if(varEl)varEl.textContent=(item.variant_title&&item.variant_title!=='Default Title')?item.variant_title:'';
    var priceEl=$('[data-cartpop-price]',popup);
    if(priceEl)priceEl.textContent=money(item.final_price||item.price);

    popup.classList.add('is-open');

    var upsell=$('[data-cartpop-upsell]',popup);
    var uprow=$('[data-cartpop-uprow]',popup);
    if(upsell&&uprow){
      upsell.classList.remove('is-on');
      uprow.innerHTML='';
      var pid=item.product_id;
      if(pid){
        fetch('/recommendations/products.json?product_id='+pid+'&limit=4&intent=complementary')
          .then(function(r){return r.ok?r.json():null;})
          .then(function(data){
            if(!data||!data.products||!data.products.length)return;
            var picks=data.products.filter(function(p){return p.id!==pid;}).slice(0,3);
            if(!picks.length)return;
            uprow.innerHTML=picks.map(function(p){
              var v=p.variants&&p.variants[0];
              var pimg=p.featured_image||(p.images&&p.images[0])||'';
              var purl=escapeHtml(p.url);
              return '<div class="cartpop__upitem">'+
                '<a href="'+purl+'" class="cartpop__upimg">'+(pimg?('<img src="'+pimg.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2')+'" alt="" loading="lazy">'):'')+'</a>'+
                '<a href="'+purl+'" class="cartpop__upt">'+escapeHtml(p.title)+'</a>'+
                '<span class="cartpop__upp">'+money(p.price)+'</span>'+
                (v?('<button type="button" class="cartpop__upadd" data-cartpop-upadd data-variant-id="'+v.id+'">Add</button>'):'')+
                '</div>';
            }).join('');
            upsell.classList.add('is-on');
          }).catch(function(){});
      }
    }
  }

  /* ---- add-to-cart popup: option picker (size/colour) for grid cards ----
     card-product.liquid keeps the plain instant-add form for a product
     with only one real variant - there is nothing to choose there. Any
     product with genuine options routes through here instead, so a
     shopper actually picks a size or colour rather than getting whichever
     variant happened to be "first available" silently added. Variants are
     fetched from /products/<handle>.js on click rather than embedded in
     every card up front, so a full collection grid still only ships the
     variant data for the one product someone is actually adding. */
  var COLOUR_MAP={
    black:'#111111', white:'#ffffff', grey:'#8a8a8a', gray:'#8a8a8a',
    charcoal:'#3a3d40', navy:'#111c3d', 'navy blue':'#111c3d', blue:'#1f4fa3',
    'sky blue':'#8ec9e6', red:'#c1272d', maroon:'#6d1b23', burgundy:'#5c1a2b',
    green:'#2f5d3a', olive:'#6b6f42', khaki:'#c3b28f', beige:'#e7dcc7',
    cream:'#f1e9d6', tan:'#c9a876', brown:'#5b3d2b', pink:'#e6a3b8',
    'rose gold':'#b76e79', purple:'#5a3a7a', lavender:'#c9bce0',
    orange:'#d1691f', yellow:'#e0bf3f', gold:'#b8963f', silver:'#b6b6b6',
    teal:'#1c6f6a', mint:'#a3d9bd', denim:'#3b5a7a', 'off white':'#f2efe6',
    'off-white':'#f2efe6', 'heather grey':'#9a9a9a', 'heather gray':'#9a9a9a'
  };
  /* Common apparel colour names get an exact hex, since a multi-word name
     like "Rose Gold" or "Navy Blue" is not a valid CSS colour keyword on
     its own and would silently fail (browsers drop an invalid declaration
     entirely, so it would just fall back to the plain grey swatch tile).
     Anything not in the map still gets tried as its own slug, which works
     for any of the ~140 single-word colours CSS itself recognises by name
     (e.g. "Brown", "Teal") - same map used server-side in
     snippets/colour-swatch.liquid for the PDP's own swatches, so both
     places agree on the same colour for the same value. */
  function colourSwatch(value){
    var key=value.toLowerCase().trim();
    if(COLOUR_MAP[key])return COLOUR_MAP[key];
    return key.replace(/[^a-z0-9]+/g,'')||'#cccccc';
  }

  var quickAddColourIndex=-1;

  function buildOptionGroups(product){
    var opts=$('[data-cartpop-opts]',popup);
    if(!opts)return;
    quickAddColourIndex=-1;
    /* /products/<handle>.js returns options as an array of objects
       ({name, position, values}), not plain strings - treating an entry
       as a string coerced it to "[object Object]" for both the visible
       label and the colour-name test, which is why colour options were
       rendering as plain text pills instead of swatches. */
    opts.innerHTML=product.options.map(function(opt,idx){
      var name=typeof opt==='string'?opt:opt.name;
      var values=[];
      product.variants.forEach(function(v){
        var val=v['option'+(idx+1)];
        if(val&&values.indexOf(val)===-1)values.push(val);
      });
      var isColour=/colour|color/i.test(name);
      if(isColour)quickAddColourIndex=idx;
      return '<div class="cartpop__optgroup">'+
        '<span class="mono-s cartpop__optlabel">'+escapeHtml(name)+'</span>'+
        '<div class="cartpop__optvals'+(isColour?' cartpop__optvals--colour':'')+'">'+
        values.map(function(v){
          var safe=escapeHtml(v);
          return '<button type="button" class="cartpop__optval'+(isColour?' cartpop__optval--colour':'')+'" data-opt-index="'+idx+'" data-opt-value="'+safe+'"'+
            (isColour?(' style="background-color:'+colourSwatch(v)+'" title="'+safe+'"'):'')+
            '>'+safe+'</button>';
        }).join('')+
        '</div></div>';
    }).join('');
  }

  function findQuickAddVariant(){
    if(!quickAddProduct)return null;
    var matches=quickAddProduct.variants.filter(function(v){
      return quickAddSelection.every(function(val,i){ return val!==null&&v['option'+(i+1)]===val; });
    });
    return matches[0]||null;
  }

  function paintOptionAvailability(){
    quickAddProduct.options.forEach(function(name,idx){
      $$('.cartpop__optval[data-opt-index="'+idx+'"]',popup).forEach(function(btn){
        var val=btn.getAttribute('data-opt-value');
        var test=quickAddSelection.slice();
        test[idx]=val;
        var any=quickAddProduct.variants.some(function(v){
          return test.every(function(t,i){ return t===null||v['option'+(i+1)]===t; })&&v.available;
        });
        btn.classList.toggle('is-soldout',!any);
      });
    });
  }

  function paintQuickAddState(){
    var confirmBtn=$('[data-cartpop-confirm]',popup);
    $$('.cartpop__optval',popup).forEach(function(btn){
      var idx=parseInt(btn.getAttribute('data-opt-index'),10);
      btn.classList.toggle('is-selected',quickAddSelection[idx]===btn.getAttribute('data-opt-value'));
    });
    paintOptionAvailability();
    var v=findQuickAddVariant();
    var priceEl=$('[data-cartpop-price]',popup);
    if(priceEl&&v)priceEl.textContent=money(v.price);

    /* Same gallery-sync idea as the PDP: a full variant match only exists
       once every option is picked, so swapping the photo only on `v`
       meant choosing a colour alone (with Size still unset) never showed
       that colour's actual product shot. Resolve a variant off the
       colour alone as a fallback so the image updates immediately. */
    var img=$('[data-cartpop-img]',popup);
    if(img){
      var imgVariant=v;
      if(!imgVariant&&quickAddColourIndex>-1&&quickAddSelection[quickAddColourIndex]!==null){
        imgVariant=quickAddProduct.variants.filter(function(vv){
          return vv['option'+(quickAddColourIndex+1)]===quickAddSelection[quickAddColourIndex];
        })[0]||null;
      }
      var src=(imgVariant&&imgVariant.featured_image&&imgVariant.featured_image.src)||quickAddProduct.featured_image||(quickAddProduct.images&&quickAddProduct.images[0])||'';
      if(src)img.src=src.replace(/(\.[a-z]+)(\?|$)/i,'_400x$1$2');
    }

    if(confirmBtn){
      var complete=quickAddSelection.every(function(x){return x!==null;});
      confirmBtn.disabled=!(complete&&v&&v.available);
      confirmBtn.textContent=!complete?'Select options':(v&&v.available?'Add to cart':'Sold out');
    }
  }

  function openQuickAdd(product){
    if(!popup||!product||!product.options)return;
    quickAddProduct=product;
    /* Default to the first in-stock variant's own combination (not just
       index 0 of each option independently, which could pair a colour and
       a size that don't actually exist together) - opens with the confirm
       button already enabled on a real, buyable variant instead of a
       disabled "Select options" nobody can click, which reads as broken
       and is exactly the kind of friction that costs a sale. Colours and
       sizes stay fully changeable from here; this only sets the starting
       point. */
    var defaultVariant=product.variants.filter(function(v){return v.available;})[0]||product.variants[0];
    quickAddSelection=product.options.map(function(opt,idx){
      return defaultVariant?defaultVariant['option'+(idx+1)]:null;
    });

    var eyebrow=$('[data-cartpop-eyebrow]',popup);
    if(eyebrow)eyebrow.textContent='Choose your options';

    var img=$('[data-cartpop-img]',popup);
    if(img){
      var src=product.featured_image||(product.images&&product.images[0])||'';
      img.src=src?src.replace(/(\.[a-z]+)(\?|$)/i,'_400x$1$2'):'';
    }
    var titleEl=$('[data-cartpop-title]',popup);
    if(titleEl)titleEl.textContent=product.title;
    var varEl=$('[data-cartpop-variant]',popup);
    if(varEl)varEl.textContent='';
    var priceEl=$('[data-cartpop-price]',popup);
    if(priceEl)priceEl.textContent=money(product.price_min||product.price);

    buildOptionGroups(product);
    var upsell=$('[data-cartpop-upsell]',popup);
    if(upsell)upsell.classList.remove('is-on');

    popup.classList.add('is-open','is-choosing');
    paintQuickAddState();
  }

  document.addEventListener('click',function(e){
    var qa=e.target.closest('[data-quick-add]');
    if(qa){
      e.preventDefault();
      var handle=qa.getAttribute('data-quick-add');
      qa.disabled=true;
      fetch('/products/'+handle+'.js')
        .then(function(r){return r.json();})
        .then(function(product){ qa.disabled=false; openQuickAdd(product); })
        .catch(function(){ qa.disabled=false; });
      return;
    }

    if(e.target.closest('[data-cartpop-close]')){closePopup();return;}

    var optBtn=e.target.closest('.cartpop__optval');
    if(optBtn&&!optBtn.classList.contains('is-soldout')){
      var idx=parseInt(optBtn.getAttribute('data-opt-index'),10);
      quickAddSelection[idx]=optBtn.getAttribute('data-opt-value');
      paintQuickAddState();
      return;
    }

    var confirmBtn=e.target.closest('[data-cartpop-confirm]');
    if(confirmBtn&&!confirmBtn.disabled){
      var v=findQuickAddVariant();
      if(!v)return;
      confirmBtn.disabled=true;
      confirmBtn.textContent='Adding';
      fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:v.id,quantity:1})})
        .then(function(r){ if(!r.ok)throw new Error('add failed'); return r.json(); })
        .then(function(addedItem){
          return refresh().then(function(){ openCartPopup(addedItem); });
        }).catch(function(){
          confirmBtn.disabled=false;
          confirmBtn.textContent='Add to cart';
        });
      return;
    }

    var upAdd=e.target.closest('[data-cartpop-upadd]');
    if(upAdd){
      var vid=upAdd.getAttribute('data-variant-id');
      upAdd.disabled=true;
      fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:vid,quantity:1})})
        .then(function(r){return r.ok?refresh():Promise.reject();})
        .then(function(){
          upAdd.textContent='Added';
          upAdd.classList.add('is-added');
        }).catch(function(){upAdd.disabled=false;});
    }
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closePopup();});

  /* add to cart (cards + pdp + bundle)
     Deliberately does NOT open the bag drawer. Interrupting a grid with a
     panel costs more browsing than it saves; the bag count, the shipping
     strip and the button itself all confirm the add, and the add-to-cart
     popup above gives a focused, isolated confirmation with a direct path
     to checkout. The bag icon and the shipping strip's View bag button
     still open the drawer on demand. */
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[action*="/cart/add"]');
    if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('[type="submit"]');
    var was=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Adding';}
    var items=$$('input[name="items"],input[data-bundle-id]',form).filter(function(i){return i.getAttribute('data-bundle-id');});
    var req;
    if(items.length){
      req=fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:items.map(function(i){return {id:parseInt(i.getAttribute('data-bundle-id'),10),quantity:1};})})});
    } else {
      req=fetch('/cart/add.js',{method:'POST',credentials:'same-origin',body:new FormData(form)});
    }
    var added;
    req.then(function(r){
      if(!r.ok)throw new Error('add failed');
      return r.json();
    }).then(function(json){
      added=json;
      return refresh();
    }).then(function(){
      if(btn){
        btn.textContent='Added to bag';
        btn.classList.add('is-added');
        setTimeout(function(){
          btn.textContent=was;
          btn.classList.remove('is-added');
          btn.disabled=false;
        },1600);
      }
      openCartPopup(added);
    }).catch(function(){
      /* only fall back to the full cart page if the add itself failed, so a
         sold-out variant still tells the customer something. */
      if(btn){btn.textContent=was;btn.disabled=false;}
      window.location.href='/cart';
    });
  });

  /* ---- pdp gallery: swipeable main image synced to the thumb strip ---- */
  $$('[data-gallery]').forEach(function(g){
    var main=$('[data-gallery-main]',g);
    if(!main)return;
    var slides=$$('.pdp__slide',main);
    var thumbs=$$('[data-gallery-thumb]',g);
    if(!slides.length)return;
    function mark(i){thumbs.forEach(function(t,n){t.setAttribute('aria-current',n===i?'true':'false');});}
    function gotoIndex(i){
      var s=slides[i];
      if(s)main.scrollTo({left:s.offsetLeft-main.offsetLeft,behavior:'smooth'});
      mark(i);
    }
    thumbs.forEach(function(t,i){
      t.addEventListener('click',function(){ gotoIndex(i); });
    });
    var tick;
    main.addEventListener('scroll',function(){
      clearTimeout(tick);
      tick=setTimeout(function(){
        var w=main.clientWidth||1;
        var i=Math.round(main.scrollLeft/w);
        if(i<0)i=0;
        if(i>slides.length-1)i=slides.length-1;
        mark(i);
        var active=thumbs[i];
        if(active&&active.scrollIntoView)active.scrollIntoView({inline:'nearest',block:'nearest',behavior:'smooth'});
      },90);
    },{passive:true});
    /* Exposes a way for the variant picker below to jump the gallery to a
       specific colour's photo - see the "gallery sync" note in the pdp
       variant picker. Keyed by Shopify image id, which a variant's
       featured_image carries too, so the two line up without guessing. */
    g.pdpGoToImage=function(imageId){
      if(!imageId)return;
      for(var i=0;i<slides.length;i++){
        if(slides[i].getAttribute('data-image-id')===String(imageId)){ gotoIndex(i); return; }
      }
    };
    mark(0);
  });

  /* ---- pdp variant picker ----
     The size/colour radios are named option1..option3, but Shopify's cart only
     reads the hidden <select name="id">. Without this, picking a size changed
     nothing and the first available variant was always added. */
  $$('form.pdp__form').forEach(function(form){
    var dataEl=$('[data-pdp-variants]',form);
    if(!dataEl)return;
    var variants;
    try{ variants=JSON.parse(dataEl.textContent||'[]'); }catch(err){ return; }
    if(!variants.length)return;

    var idField=$('select[name="id"],input[name="id"]',form);
    var addBtn=$('[data-pdp-add]',form);
    var buyBtn=$('[data-pdp-buy]',form);
    var scope=form.closest('.pdp__info')||document;
    var priceEl=$('[data-pdp-price]',scope);
    var compareEl=$('[data-pdp-compare]',scope);
    var saveEl=$('[data-pdp-save]',scope);
    var stockEl=$('[data-pdp-stock]',scope);
    var groups=$$('.pdp__opt',form);

    /* Which option group is the colour one, if any - Liquid already marks
       it with data-colour="true". Used below to jump the gallery to that
       colour's photo as soon as it's picked, independent of whether the
       rest of the selection (e.g. Size) is complete yet. */
    var colourGroup=groups.filter(function(g){return g.hasAttribute('data-colour');})[0];
    var colourIdx=colourGroup?parseInt(colourGroup.getAttribute('data-option-index'),10):-1;

    function chosen(){
      return groups.map(function(g){
        var r=$('input[type="radio"]:checked',g);
        return r?r.value:null;
      });
    }

    function findVariant(sel){
      for(var i=0;i<variants.length;i++){
        var v=variants[i],ok=true;
        for(var j=0;j<sel.length;j++){
          if(sel[j]===null){ok=false;break;}
          if(String(v.options[j])!==String(sel[j])){ok=false;break;}
        }
        if(ok)return v;
      }
      return null;
    }

    function paintAvailability(sel){
      groups.forEach(function(g,idx){
        $$('input[type="radio"]',g).forEach(function(r){
          var test=sel.slice();
          test[idx]=r.value;
          var any=variants.some(function(v){
            for(var j=0;j<test.length;j++){
              if(test[j]===null)continue;
              if(String(v.options[j])!==String(test[j]))return false;
            }
            return v.available;
          });
          var lab=r.closest('.swatch');
          if(lab)lab.classList.toggle('is-soldout',!any);
        });
        var picked=$('input[type="radio"]:checked',g);
        var lbl=$('[data-option-label]',g);
        if(lbl&&picked)lbl.textContent=picked.value;
      });
    }

    function sync(){
      var sel=chosen();
      paintAvailability(sel);
      var v=findVariant(sel);

      /* ---- gallery sync ----
         findVariant only resolves once every option is picked, so on a
         product with both Size and Colour, choosing Black and leaving
         Size unset left the gallery on whatever image happened to load
         first - the photo never actually reflected the colour that was
         selected. This resolves a variant off the colour alone (ignoring
         the rest of the selection) so the image updates the moment a
         colour is chosen, not only once the whole combination is valid. */
      if(colourIdx>-1&&sel[colourIdx]!==null){
        var galleryVariant=v||variants.filter(function(vv){
          return String(vv.options[colourIdx])===String(sel[colourIdx]);
        })[0];
        if(galleryVariant&&galleryVariant.featured_image){
          var gallery=$('[data-gallery]');
          if(gallery&&gallery.pdpGoToImage)gallery.pdpGoToImage(galleryVariant.featured_image.id);
        }
      }

      if(!v){
        if(addBtn){addBtn.disabled=true;addBtn.textContent='Unavailable';}
        if(buyBtn)buyBtn.disabled=true;
        if(stockEl)stockEl.textContent='That combination is not available';
        return;
      }

      if(idField)idField.value=v.id;
      if(priceEl)priceEl.textContent=money(v.price);

      var onSale=v.compare_at_price&&v.compare_at_price>v.price;
      if(compareEl){
        compareEl.hidden=!onSale;
        if(onSale)compareEl.textContent=money(v.compare_at_price);
      }
      if(saveEl){
        saveEl.hidden=!onSale;
        if(onSale)saveEl.textContent='Save '+money(v.compare_at_price-v.price);
      }

      if(addBtn){
        addBtn.disabled=!v.available;
        addBtn.textContent=v.available?('Add to cart · '+money(v.price)):'Sold out';
      }
      if(buyBtn)buyBtn.disabled=!v.available;

      if(stockEl){
        if(!v.available){
          stockEl.textContent='Out of stock in this size';
        } else if(typeof v.inventory_quantity==='number'&&v.inventory_quantity>0&&v.inventory_quantity<=5){
          stockEl.textContent='Only '+v.inventory_quantity+' left';
        } else {
          stockEl.textContent='';
        }
      }

      try{
        var u=new URL(window.location.href);
        u.searchParams.set('variant',v.id);
        window.history.replaceState({},'',u.toString());
      }catch(err){}
    }

    $$('input[type="radio"]',form).forEach(function(r){r.addEventListener('change',sync);});
    sync();
  });

  /* generic horizontal rail scroll */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-rail-prev],[data-rail-next]');
    if (!btn) return;
    var railId = btn.getAttribute('data-rail-prev') || btn.getAttribute('data-rail-next');
    var rail = document.getElementById(railId);
    if (!rail) return;
    var card = rail.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
    var dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
    rail.scrollBy({ left: step * dir, behavior: 'smooth' });
  });

  /* ---- wishlist ---- */
  var WL_KEY = 'hb_wishlist';
  function wlGet(){ try{ return JSON.parse(localStorage.getItem(WL_KEY)||'[]'); }catch(e){ return []; } }
  function wlSet(list){ try{ localStorage.setItem(WL_KEY, JSON.stringify(list)); }catch(e){} }
  function wlToggle(handle){
    var list = wlGet();
    var i = list.indexOf(handle);
    if(i>-1) list.splice(i,1); else list.push(handle);
    wlSet(list);
  }
  function wlPaint(){
    var list = wlGet();
    $$('[data-wishlist-toggle]').forEach(function(b){
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.querySelector('[data-wishlist-label]');
      if(label) label.textContent = on ? 'Saved' : 'Save';
    });
    $$('[data-wishlist-count]').forEach(function(el){
      el.textContent = list.length;
      el.classList.toggle('is-on', list.length > 0);
    });
  }
  wlPaint();
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-wishlist-toggle]');
    if(!b) return;
    e.preventDefault();
    wlToggle(b.getAttribute('data-handle'));
    wlPaint();
  });

  var wlGrid = $('[data-wishlist-grid]');
  if(wlGrid){
    (function(){
      var handles = wlGet();
      var emptyEl = $('[data-wishlist-empty]');
      if(!handles.length){
        if(emptyEl) emptyEl.style.display = 'flex';
        return;
      }

      /* reuse whatever icon the theme is currently using, rather than
         hardcoding a second copy that drifts when the snippet changes */
      var srcIcon = $('.hdr a[aria-label="Wishlist"] svg');
      var iconMarkup = srcIcon ? srcIcon.outerHTML : '';

      Promise.all(handles.map(function(h){
        return fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
      })).then(function(products){
        var found = products.filter(Boolean);
        if(found.length !== handles.length) wlSet(found.map(function(p){ return p.handle; }));
        if(!found.length){
          if(emptyEl) emptyEl.style.display = 'flex';
          return;
        }
        wlGrid.innerHTML = found.map(function(p){
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var cutout = /\.png/i.test(img || '');
          var handle = escapeHtml(p.handle);
          return '<div class="card">' +
            '<a href="/products/' + handle + '" class="card__media' + (cutout ? ' is-cutout' : '') + '">' +
            (img ? ('<img src="' + img + '" alt="" loading="lazy">') : '') +
            '</a>' +
            '<button type="button" class="wishlist-btn is-saved" data-wishlist-toggle data-handle="' + handle + '" aria-label="Remove from wishlist" aria-pressed="true">' +
            iconMarkup +
            '</button>' +
            '<div class="card__body"><div class="card__row"><a href="/products/' + handle + '" class="card__t">' + escapeHtml(p.title) + '</a>' +
            '<span class="card__p">' + money(p.price) + '</span></div></div>' +
            '<a class="btn btn--card" href="/products/' + handle + '">View product</a>' +
            '</div>';
        }).join('');
        wlPaint();
      });
    })();
  }

  /* ---- student verify ---- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-student-copy]');
    if(!btn) return;
    var codeEl = btn.parentElement.querySelector('[data-student-code]');
    var code = codeEl ? codeEl.textContent.trim() : '';
    if(navigator.clipboard) navigator.clipboard.writeText(code).catch(function(){});
    var was = btn.textContent;
    btn.textContent = 'Copied';
    setTimeout(function(){ btn.textContent = was; }, 1500);
  });

  /* ---- pdp size & fit guide panel ---- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-panel]');
    if(!btn) return;
    var target = document.getElementById('size-guide');
    if(target){
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var scope = btn.closest('.pdp') || document;
    var det = scope.querySelector('.acc details');
    if(det){
      det.open = true;
      det.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---- write a review ---- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-write-review]');
    if(!b) return;
    e.preventDefault();
    var jm = document.querySelector('.jdgm-write-rev-link');
    if(jm){
      jm.click();
      var form = document.querySelector('.jdgm-form-wrapper, .jdgm-form');
      if(form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var email = b.getAttribute('data-email') || '';
    var prod = b.getAttribute('data-product') || '';
    if(!email) return;
    window.location.href = 'mailto:' + email +
      '?subject=' + encodeURIComponent('Review: ' + prod) +
      '&body=' + encodeURIComponent('Rating out of 5:\n\nMy review:\n\n');
  });
})();
